import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';

import { BudgetDTO, BudgetFilters } from '../../models/budget.model';

@Injectable({
  providedIn: "root"
})
export class LaravelBudgetService {
  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
      list: environment.baseUrl + "/api/budgets",
      show: environment.baseUrl + "/api/budget",
      store: environment.baseUrl + "/api/budget",
      destroy: environment.baseUrl + "/api/budget",
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: BudgetFilters,
    includes?: string[]
  ): Observable<ListResultDTO<BudgetDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
      if (filters.project_id) params["project_id"] = "" + filters.project_id;
    }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<BudgetDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<BudgetDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public show(id: number): Observable<BudgetDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<BudgetDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(budget: BudgetDTO): Observable<BudgetDTO> {
    if (budget.id) {
      return this.httpClient.put<BudgetDTO>(`${this.ROUTES.store}`, { budget });
    } else {
      return this.httpClient.post<BudgetDTO>(`${this.ROUTES.store}`, { budget });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
